<template>
  <div class="header">
    <ul class="menu" :class="{ 'open' : open}">
      <li class="menu-control">
        <a href="#" @click="open = !open, openMenu()" :class="{ 'open' : open}">.
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
            <path fill="#fff" d="M491.318,235.318H20.682C9.26,235.318,0,244.577,0,256s9.26,20.682,20.682,20.682h470.636
              c11.423,0,20.682-9.259,20.682-20.682C512,244.578,502.741,235.318,491.318,235.318z"/>
            <path fill="#fff" d="M491.318,78.439H20.682C9.26,78.439,0,87.699,0,99.121c0,11.422,9.26,20.682,20.682,20.682h470.636
              c11.423,0,20.682-9.26,20.682-20.682C512,87.699,502.741,78.439,491.318,78.439z"/>
            <path fill="#fff" d="M491.318,392.197H20.682C9.26,392.197,0,401.456,0,412.879s9.26,20.682,20.682,20.682h470.636
              c11.423,0,20.682-9.259,20.682-20.682S502.741,392.197,491.318,392.197z"/>
        </svg>
        </a>
      </li>
      <li>
        <div class="bbc">Zlecenia</div>
        <router-link to="/dashboard">.
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve">
            <path fill="#fff" d="M38.914,0H6.5v60h47V14.586L38.914,0z M39.5,3.414L50.086,14H39.5V3.414z M8.5,58V2h29v14h14v42H8.5z"/>
            <path fill="#fff" d="M42.5,21h-16c-0.552,0-1,0.447-1,1s0.448,1,1,1h16c0.552,0,1-0.447,1-1S43.052,21,42.5,21z"/>
            <path fill="#fff" d="M22.875,18.219l-4.301,3.441l-1.367-1.367c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l2,2
              C17.987,23.901,18.243,24,18.5,24c0.22,0,0.441-0.072,0.624-0.219l5-4c0.432-0.346,0.501-0.975,0.156-1.406
              C23.936,17.943,23.306,17.874,22.875,18.219z"/>
            <path fill="#fff" d="M42.5,32h-16c-0.552,0-1,0.447-1,1s0.448,1,1,1h16c0.552,0,1-0.447,1-1S43.052,32,42.5,32z"/>
            <path fill="#fff" d="M22.875,29.219l-4.301,3.441l-1.367-1.367c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l2,2
              C17.987,34.901,18.243,35,18.5,35c0.22,0,0.441-0.072,0.624-0.219l5-4c0.432-0.346,0.501-0.975,0.156-1.406
              C23.936,28.943,23.306,28.874,22.875,29.219z"/>
            <path fill="#fff" d="M42.5,43h-16c-0.552,0-1,0.447-1,1s0.448,1,1,1h16c0.552,0,1-0.447,1-1S43.052,43,42.5,43z"/>
            <path fill="#fff" d="M22.875,40.219l-4.301,3.441l-1.367-1.367c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l2,2
              C17.987,45.901,18.243,46,18.5,46c0.22,0,0.441-0.072,0.624-0.219l5-4c0.432-0.346,0.501-0.975,0.156-1.406
              C23.936,39.943,23.306,39.874,22.875,40.219z"/>
          </svg>
        </router-link>
      </li>
      <li title="Markety" v-if="$parent.grantPermission(['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_COORDINATOR'])"> 
        <div class="bbc">Markety</div>
        <router-link to="/markets">.
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <path fill="#fff" d="M488.468,448.903h-8.532V226.4C499.202,214.003,512,192.386,512,167.822c0-1.305-0.341-2.588-0.988-3.721L451.499,59.953
                c-4.18-7.313-12.009-11.857-20.432-11.857H80.933c-8.423,0-16.252,4.543-20.432,11.857L0.988,164.101
                C0.341,165.234,0,166.518,0,167.822c0,24.564,12.798,46.181,32.064,58.578v222.503h-8.532c-4.142,0-7.5,3.358-7.5,7.5
                c0,4.142,3.358,7.5,7.5,7.5h464.936c4.143,0,7.5-3.358,7.5-7.5C495.968,452.261,492.61,448.903,488.468,448.903z M15.517,175.322
                h24.044c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5H20.424l53.101-92.927c1.516-2.652,4.354-4.299,7.408-4.299h350.134
                c3.054,0,5.893,1.647,7.408,4.299l53.1,92.927h-19.141c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h24.048
                c-3.667,26.584-26.532,47.125-54.108,47.125c-27.575,0-50.429-20.543-54.097-47.125h52.096c4.143,0,7.5-3.358,7.5-7.5
                c0-4.142-3.357-7.5-7.5-7.5H71.631c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h52.091
                c-3.668,26.582-26.523,47.125-54.097,47.125C42.049,222.447,19.184,201.906,15.517,175.322z M372.222,175.322
                c-3.668,26.582-26.523,47.125-54.097,47.125c-27.575,0-50.429-20.543-54.097-47.125H372.222z M247.972,175.322
                c-3.668,26.582-26.523,47.125-54.097,47.125c-27.574,0-50.429-20.543-54.097-47.125H247.972z M424.854,448.904h-81.193v-25.081
                h81.193V448.904z M424.854,408.823h-81.193V271.516h81.193V408.823z M464.936,448.904h-25.081V264.016c0-4.142-3.357-7.5-7.5-7.5
                h-96.193c-4.143,0-7.5,3.358-7.5,7.5v184.887H47.064V233.674c7.081,2.433,14.665,3.773,22.561,3.773
                c27.095,0,50.624-15.556,62.125-38.207c11.501,22.65,35.03,38.207,62.125,38.207c27.095,0,50.624-15.556,62.125-38.207
                c11.501,22.65,35.03,38.207,62.125,38.207c27.095,0,50.624-15.556,62.125-38.207c11.501,22.65,35.03,38.207,62.125,38.207
                c7.896,0,15.48-1.34,22.561-3.772V448.904z"/>
              <path fill="#fff" d="M296.081,256.516H79.645c-4.142,0-7.5,3.358-7.5,7.5v152.307c0,4.142,3.358,7.5,7.5,7.5h216.436
                c4.143,0,7.5-3.358,7.5-7.5V264.016C303.581,259.873,300.224,256.516,296.081,256.516z M288.581,408.823H87.145V271.516h201.436
                V408.823z"/>
          </svg>
        </router-link>
      </li>
      <li title="Użytkownicy" v-if="$parent.grantPermission(['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_COORDINATOR'])">
        <div class="bbc">Użytkownicy</div>
        <router-link to="/users">.
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve">
            <path fill="#fff" d="M55.517,46.55l-9.773-4.233c-0.23-0.115-0.485-0.396-0.704-0.771l6.525-0.005c0.114,0.011,2.804,0.257,4.961-0.67
              c0.817-0.352,1.425-1.047,1.669-1.907c0.246-0.868,0.09-1.787-0.426-2.523c-1.865-2.654-6.218-9.589-6.354-16.623
              c-0.003-0.121-0.397-12.083-12.21-12.18c-1.739,0.014-3.347,0.309-4.81,0.853c-0.319-0.813-0.789-1.661-1.488-2.459
              C30.854,3.688,27.521,2.5,23,2.5s-7.854,1.188-9.908,3.53c-2.368,2.701-2.148,5.976-2.092,6.525v5.319c-0.64,0.729-1,1.662-1,2.625
              v4c0,1.217,0.553,2.352,1.497,3.109c0.916,3.627,2.833,6.36,3.503,7.237v3.309c0,0.968-0.528,1.856-1.377,2.32l-8.921,4.866
              C1.801,46.924,0,49.958,0,53.262V57.5h44h2h14v-3.697C60,50.711,58.282,47.933,55.517,46.55z M44,55.5H2v-2.238
              c0-2.571,1.402-4.934,3.659-6.164l8.921-4.866C16.073,41.417,17,39.854,17,38.155v-4.019l-0.233-0.278
              c-0.024-0.029-2.475-2.994-3.41-7.065l-0.091-0.396l-0.341-0.22C12.346,25.803,12,25.176,12,24.5v-4c0-0.561,0.238-1.084,0.67-1.475
              L13,18.728V12.5l-0.009-0.131c-0.003-0.027-0.343-2.799,1.605-5.021C16.253,5.458,19.081,4.5,23,4.5
              c3.905,0,6.727,0.951,8.386,2.828c0.825,0.932,1.24,1.973,1.447,2.867c0.016,0.07,0.031,0.139,0.045,0.208
              c0.014,0.071,0.029,0.142,0.04,0.21c0.013,0.078,0.024,0.152,0.035,0.226c0.008,0.053,0.016,0.107,0.022,0.158
              c0.015,0.124,0.027,0.244,0.035,0.355c0.001,0.009,0.001,0.017,0.001,0.026c0.007,0.108,0.012,0.21,0.015,0.303
              c0,0.018,0,0.033,0.001,0.051c0.002,0.083,0.002,0.162,0.001,0.231c0,0.01,0,0.02,0,0.03c-0.004,0.235-0.02,0.375-0.02,0.378
              L33,18.728l0.33,0.298C33.762,19.416,34,19.939,34,20.5v4c0,0.873-0.572,1.637-1.422,1.899l-0.498,0.153l-0.16,0.495
              c-0.669,2.081-1.622,4.003-2.834,5.713c-0.297,0.421-0.586,0.794-0.837,1.079L28,34.123v4.125c0,0.253,0.025,0.501,0.064,0.745
              c0.008,0.052,0.022,0.102,0.032,0.154c0.039,0.201,0.091,0.398,0.155,0.59c0.015,0.045,0.031,0.088,0.048,0.133
              c0.078,0.209,0.169,0.411,0.275,0.605c0.012,0.022,0.023,0.045,0.035,0.067c0.145,0.256,0.312,0.499,0.504,0.723l0.228,0.281h0.039
              c0.343,0.338,0.737,0.632,1.185,0.856l9.553,4.776C42.513,48.374,44,50.78,44,53.457V55.5z M58,55.5H46v-2.043
              c0-3.439-1.911-6.53-4.986-8.068l-6.858-3.43c0.169-0.386,0.191-0.828,0.043-1.254c-0.245-0.705-0.885-1.16-1.63-1.16h-2.217
              c-0.046-0.081-0.076-0.17-0.113-0.256c-0.05-0.115-0.109-0.228-0.142-0.349C30.036,38.718,30,38.486,30,38.248v-3.381
              c0.229-0.28,0.47-0.599,0.719-0.951c1.239-1.75,2.232-3.698,2.954-5.799C35.084,27.47,36,26.075,36,24.5v-4
              c0-0.963-0.36-1.896-1-2.625v-5.319c0.026-0.25,0.082-1.069-0.084-2.139c1.288-0.506,2.731-0.767,4.29-0.78
              c9.841,0.081,10.2,9.811,10.21,10.221c0.147,7.583,4.746,14.927,6.717,17.732c0.169,0.24,0.22,0.542,0.139,0.827
              c-0.046,0.164-0.178,0.462-0.535,0.615c-1.68,0.723-3.959,0.518-4.076,0.513h-6.883c-0.643,0-1.229,0.327-1.568,0.874
              c-0.338,0.545-0.37,1.211-0.086,1.783c0.313,0.631,0.866,1.474,1.775,1.927l9.747,4.222C56.715,49.396,58,51.482,58,53.803V55.5z"/>
          </svg>
        </router-link>
      </li>
      <li title="Produkty" v-if="$parent.grantPermission(['ROLE_COORDINATOR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])">
        <div class="bbc">Produkty</div>
        <router-link to="/products">.
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 56.004 56.004" style="enable-background:new 0 0 56.004 56.004;" xml:space="preserve">
            <path fill="#fff" d="M51.426,44.336c-0.429-4.107-3.852-7.332-7.953-7.332c-2.564,0-4.984,1.286-6.48,3.402
              c-0.291-0.051-0.586-0.076-0.883-0.076c-2.32,0-4.381,1.577-5.066,3.813c-1.907,1.131-3.116,3.241-3.116,5.502
              c0,3.507,2.785,6.359,6.208,6.359h10.774c0.06,0,0.118-0.004,0.171-0.008c0.062,0.004,0.124,0.008,0.188,0.008h4.31
              c3.225,0,5.849-2.687,5.849-5.989C55.427,47.415,53.785,45.142,51.426,44.336z M49.578,54.004l-4.352-0.003l-0.17-0.006
              l-10.922,0.009c-2.32,0-4.208-1.956-4.208-4.359c0-1.665,0.949-3.21,2.417-3.935l0.435-0.214l0.102-0.475
              c0.331-1.56,1.689-2.691,3.229-2.691c0.345,0,0.688,0.057,1.02,0.168l0.777,0.261l0.408-0.711c1.096-1.906,3.024-3.044,5.158-3.044
              c3.265,0,5.955,2.747,5.998,6.123l0.011,0.813l0.799,0.155c1.823,0.354,3.146,2.002,3.146,3.919
              C53.427,52.214,51.7,54.004,49.578,54.004z"/>
            <path fill="#fff" d="M25.577,41c-0.827,0-1.637-0.016-2.432-0.044c-0.486-0.018-0.955-0.049-1.429-0.077c-0.293-0.017-0.595-0.028-0.883-0.049
              c-0.63-0.045-1.242-0.104-1.847-0.167c-0.114-0.012-0.233-0.02-0.346-0.032c-0.693-0.076-1.368-0.163-2.026-0.259
              c-0.017-0.002-0.034-0.004-0.051-0.007c-3.385-0.5-6.29-1.263-8.561-2.169c-0.012-0.004-0.024-0.009-0.036-0.014
              c-0.419-0.168-0.812-0.342-1.186-0.519c-0.043-0.021-0.089-0.041-0.132-0.062c-0.336-0.162-0.647-0.328-0.945-0.497
              c-0.07-0.04-0.144-0.079-0.212-0.12c-0.259-0.152-0.495-0.307-0.721-0.463c-0.086-0.06-0.175-0.12-0.257-0.18
              c-0.191-0.141-0.362-0.283-0.526-0.426c-0.089-0.079-0.179-0.157-0.26-0.236c-0.134-0.13-0.252-0.261-0.363-0.392
              c-0.078-0.092-0.153-0.185-0.219-0.277c-0.088-0.123-0.163-0.246-0.231-0.369c-0.054-0.099-0.102-0.198-0.143-0.297
              c-0.049-0.121-0.088-0.242-0.116-0.362c-0.038-0.162-0.079-0.325-0.079-0.485v-8.207c0.028,0.026,0.063,0.051,0.092,0.077
              c0.218,0.191,0.44,0.382,0.69,0.566C7.126,28.786,14.659,31,25.577,31c10.872,0,18.386-2.196,22.169-5.028
              c0.302-0.22,0.574-0.447,0.83-0.678l0.001,0V34c0,0.553,0.447,1,1,1s1-0.447,1-1V22v-0.5v-12V9c0-0.182-0.062-0.343-0.146-0.49
              C49.273,4.22,40.654,0,25.577,0C10.5,0,1.881,4.22,0.724,8.51C0.639,8.657,0.577,8.818,0.577,9v0.5v12V22v11.5V34v12
              c0,0.161,0.042,0.313,0.115,0.448c1.139,4.833,10.691,7.68,19.81,8.364c0.025,0.002,0.051,0.003,0.076,0.003
              c0.519,0,0.957-0.399,0.996-0.925c0.041-0.551-0.371-1.031-0.922-1.072C9.538,51.984,3.062,48.6,2.609,45.838
              c-0.008-0.045-0.019-0.088-0.032-0.131v-8.414c0.028,0.026,0.063,0.051,0.092,0.077c0.218,0.191,0.44,0.382,0.69,0.566
              C7.126,40.786,14.659,43,25.577,43c0.553,0,1-0.447,1-1S26.13,41,25.577,41z M3.179,13.797c0.3,0.236,0.624,0.469,0.975,0.696
              c0.073,0.047,0.155,0.093,0.231,0.14c0.294,0.183,0.605,0.362,0.932,0.538c0.121,0.065,0.242,0.129,0.367,0.193
              c0.365,0.186,0.748,0.366,1.151,0.542c0.066,0.029,0.126,0.059,0.193,0.087c0.469,0.199,0.967,0.389,1.485,0.572
              c0.143,0.051,0.293,0.099,0.44,0.149c0.412,0.139,0.838,0.272,1.279,0.401c0.159,0.046,0.315,0.094,0.478,0.139
              c0.585,0.162,1.189,0.316,1.823,0.458c0.087,0.02,0.181,0.037,0.269,0.056c0.559,0.122,1.139,0.235,1.735,0.34
              c0.202,0.036,0.407,0.07,0.613,0.104c0.567,0.093,1.151,0.179,1.75,0.257c0.154,0.02,0.301,0.042,0.457,0.062
              c0.744,0.09,1.514,0.167,2.305,0.233c0.195,0.016,0.398,0.028,0.596,0.042c0.633,0.046,1.28,0.084,1.942,0.114
              c0.241,0.011,0.481,0.022,0.727,0.03c0.863,0.03,1.741,0.05,2.65,0.05s1.788-0.021,2.65-0.05c0.245-0.008,0.485-0.02,0.727-0.03
              c0.662-0.03,1.309-0.068,1.942-0.114c0.198-0.015,0.4-0.026,0.596-0.042c0.791-0.065,1.561-0.143,2.305-0.233
              c0.156-0.019,0.303-0.042,0.457-0.062c0.599-0.078,1.182-0.164,1.75-0.257c0.206-0.034,0.411-0.068,0.613-0.104
              c0.596-0.105,1.176-0.218,1.735-0.34c0.088-0.019,0.182-0.036,0.269-0.056c0.634-0.142,1.238-0.296,1.823-0.458
              c0.163-0.045,0.319-0.092,0.478-0.139c0.441-0.128,0.867-0.262,1.279-0.401c0.147-0.05,0.297-0.098,0.44-0.149
              c0.518-0.184,1.017-0.374,1.485-0.572c0.067-0.028,0.127-0.059,0.193-0.087c0.403-0.176,0.786-0.356,1.151-0.542
              c0.125-0.064,0.247-0.128,0.367-0.193c0.327-0.175,0.638-0.354,0.932-0.538c0.076-0.047,0.158-0.093,0.231-0.14
              c0.351-0.227,0.675-0.459,0.975-0.696c0.075-0.06,0.142-0.12,0.215-0.18c0.13-0.108,0.267-0.215,0.387-0.324V21.5
              c0,0.161-0.041,0.323-0.079,0.485c-0.028,0.121-0.067,0.241-0.116,0.362c-0.04,0.099-0.089,0.198-0.143,0.297
              c-0.067,0.123-0.142,0.246-0.231,0.369c-0.066,0.092-0.141,0.185-0.219,0.277c-0.111,0.131-0.229,0.262-0.363,0.392
              c-0.081,0.079-0.17,0.157-0.26,0.236c-0.164,0.143-0.335,0.285-0.526,0.426c-0.082,0.061-0.17,0.12-0.257,0.18
              c-0.226,0.156-0.462,0.311-0.721,0.463c-0.068,0.041-0.141,0.08-0.212,0.12c-0.298,0.168-0.609,0.334-0.945,0.497
              c-0.043,0.021-0.088,0.041-0.132,0.062c-0.375,0.177-0.767,0.351-1.186,0.519c-0.012,0.005-0.024,0.009-0.036,0.014
              c-2.271,0.907-5.176,1.67-8.561,2.169c-0.017,0.002-0.034,0.004-0.051,0.007c-0.658,0.097-1.333,0.184-2.026,0.259
              c-0.113,0.012-0.232,0.02-0.346,0.032c-0.605,0.063-1.217,0.121-1.847,0.167c-0.288,0.021-0.59,0.032-0.883,0.049
              c-0.474,0.028-0.943,0.059-1.429,0.077C27.214,28.984,26.404,29,25.577,29s-1.637-0.016-2.432-0.044
              c-0.486-0.018-0.955-0.049-1.429-0.077c-0.293-0.017-0.595-0.028-0.883-0.049c-0.63-0.045-1.242-0.104-1.847-0.167
              c-0.114-0.012-0.233-0.02-0.346-0.032c-0.693-0.076-1.368-0.163-2.026-0.259c-0.017-0.002-0.034-0.004-0.051-0.007
              c-3.385-0.5-6.29-1.263-8.561-2.169c-0.012-0.004-0.024-0.009-0.036-0.014c-0.419-0.168-0.812-0.342-1.186-0.519
              c-0.043-0.021-0.089-0.041-0.132-0.062c-0.336-0.162-0.647-0.328-0.945-0.497c-0.07-0.04-0.144-0.079-0.212-0.12
              c-0.259-0.152-0.495-0.307-0.721-0.463c-0.086-0.06-0.175-0.12-0.257-0.18c-0.191-0.141-0.362-0.283-0.526-0.426
              c-0.089-0.079-0.179-0.157-0.26-0.236c-0.134-0.13-0.252-0.261-0.363-0.392c-0.078-0.092-0.153-0.185-0.219-0.277
              c-0.088-0.123-0.163-0.246-0.231-0.369c-0.054-0.099-0.102-0.198-0.143-0.297c-0.049-0.121-0.088-0.242-0.116-0.362
              c-0.038-0.162-0.079-0.325-0.079-0.485v-8.207c0.12,0.109,0.257,0.216,0.387,0.324C3.036,13.677,3.103,13.737,3.179,13.797z
              M25.577,2c13.555,0,23,3.952,23,7.5s-9.445,7.5-23,7.5s-23-3.952-23-7.5S12.022,2,25.577,2z"/>
          </svg>
        </router-link>
      </li>
      <li title="Zdania prawne" v-if="$parent.grantPermission(['ROLE_COORDINATOR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])">
        <div class="bbc">Zdania prawne</div>
        <router-link to="/legals">.
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 128 128" style="enable-background:new 0 0 128 128;" xml:space="preserve">
          <path fill="#fff" d="M52.14,43.72c-1.4-0.85-2.69-1.65-3.98-2.43c-6.59-3.99-9.3-9.96-8.73-17.48c0.58-7.59,4.41-13.14,11.39-16.1
            c8.56-3.63,17.25-3.57,25.54,0.85c6.41,3.42,9.21,9.23,9.43,16.36c0.05,1.67-0.97,2.82-2.41,2.91c-1.51,0.1-2.55-0.93-2.74-2.69
            c-0.14-1.27-0.18-2.57-0.48-3.81c-1.16-4.77-4.3-7.8-8.79-9.43c-5.83-2.12-11.74-2.08-17.55,0.05c-6.58,2.42-9.81,7.85-9.25,14.91
            c0.32,4.06,2,7.33,5.44,9.41c3.97,2.4,8.12,4.5,12.23,6.67c4.64,2.45,9.38,4.72,13.97,7.25c3.48,1.92,6.53,4.44,8.19,8.21
            c3.57,8.08,2.28,20.94-10.01,26.15c-0.35,0.15-0.7,0.3-1.11,0.48c1.92,1.24,3.77,2.34,5.53,3.57c5.96,4.17,7.81,10.11,7.16,17.05
            c-0.86,9.19-7.57,15.43-17.03,17.18c-6.32,1.17-12.57,0.86-18.49-1.88c-7.17-3.32-10.76-9.08-11.06-16.93
            c-0.07-1.76,0.91-2.94,2.4-3.04c1.51-0.1,2.56,1.02,2.76,2.83c0.17,1.51,0.27,3.06,0.71,4.49c1.19,3.89,3.89,6.53,7.58,8.04
            c6.57,2.69,13.24,2.73,19.79-0.01c5.93-2.48,8.76-7.73,8.27-14.34c-0.34-4.57-2.52-7.94-6.4-10.11c-4.93-2.75-10.01-5.23-15-7.86
            c-3.93-2.07-7.92-4.07-11.72-6.35c-6.55-3.93-8.95-10.05-8.33-17.42c0.64-7.52,4.56-12.83,11.43-15.96
            C51.26,44.12,51.64,43.94,52.14,43.72z M44.25,62.21c0.44,1.89,0.7,3.86,1.37,5.67c1.14,3.11,3.73,4.99,6.5,6.49
            c4.36,2.37,8.81,4.56,13.24,6.8c0.33,0.17,0.78,0.24,1.14,0.18c1.38-0.25,2.77-0.47,4.1-0.91c5.53-1.81,9.29-5.32,10.16-11.29
            c0.93-6.33-1.23-11.25-6.93-14.44c-0.56-0.31-1.09-0.68-1.66-0.97c-3.21-1.64-6.52-3.11-9.6-4.96c-2.55-1.53-4.95-1.45-7.63-0.58
            C48.32,50.36,44.32,55.63,44.25,62.21z"/>
          </svg>
        </router-link>
      </li>
      <li title="API" v-if="$parent.grantPermission(['ROLE_ADMIN', 'ROLE_COORDINATOR', 'ROLE_SUPER_ADMIN'])">
        <div class="bbc">API</div>
        <router-link to="">.
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 511 511">
            <path fill="#fff" d="M492.168,309.579l-17.626-10.177c2.96-14.723,4.458-29.466,4.458-43.902c0-14.646-1.474-29.403-4.384-43.946l17.552-10.134
              c5.436-3.138,9.325-8.206,10.949-14.269s0.791-12.396-2.348-17.832l-48-83.139c-3.139-5.436-8.206-9.325-14.269-10.949
              c-6.064-1.624-12.396-0.791-17.833,2.348l-17.566,10.142C380.912,68.2,354.798,53.092,327,43.692V23.5
              C327,10.542,316.458,0,303.5,0h-96C194.542,0,184,10.542,184,23.5v20.193c-27.65,9.362-53.728,24.49-75.999,44.088L90.332,77.579
              c-5.437-3.139-11.77-3.973-17.833-2.348c-6.063,1.625-11.13,5.513-14.269,10.949l-48,83.139
              c-3.139,5.436-3.972,11.769-2.348,17.832s5.513,11.131,10.949,14.269l17.626,10.177C33.499,226.32,32,241.063,32,255.5
              c0,14.644,1.474,29.401,4.384,43.945l-17.552,10.134c-11.222,6.479-15.08,20.879-8.602,32.102l48,83.139
              c6.479,11.221,20.879,15.08,32.102,8.601l17.565-10.142c22.19,19.521,48.303,34.629,76.103,44.03V487.5
              c0,12.958,10.542,23.5,23.5,23.5h96c12.958,0,23.5-10.542,23.5-23.5v-20.193c27.651-9.362,53.729-24.49,76-44.087l17.668,10.201
              c11.221,6.479,25.623,2.62,32.102-8.601l48-83.139C507.248,330.458,503.39,316.058,492.168,309.579z M487.779,334.181l-48,83.138
              c-2.343,4.06-7.552,5.455-11.611,3.111l-22.392-12.928c-2.845-1.643-6.43-1.242-8.842,0.989
              c-22.893,21.173-50.437,37.148-79.653,46.199c-3.14,0.973-5.281,3.877-5.281,7.164V487.5c0,4.687-3.813,8.5-8.5,8.5h-96
              c-4.687,0-8.5-3.813-8.5-8.5v-25.645c0-3.287-2.141-6.191-5.28-7.164c-29.396-9.107-56.974-25.062-79.755-46.139
              c-1.421-1.315-3.25-1.995-5.095-1.995c-1.286,0-2.579,0.33-3.748,1.005L82.832,420.43c-4.06,2.343-9.268,0.948-11.611-3.111
              l-48-83.138c-2.343-4.059-0.947-9.268,3.111-11.612l22.272-12.859c2.844-1.642,4.289-4.942,3.566-8.146
              C48.739,286.357,47,270.858,47,255.5c0-15.1,1.765-30.584,5.247-46.022c0.722-3.203-0.723-6.504-3.566-8.145L26.332,188.43
              c-1.966-1.135-3.372-2.968-3.96-5.161c-0.587-2.193-0.286-4.484,0.849-6.45l48-83.139c1.135-1.966,2.968-3.373,5.162-3.96
              c2.192-0.588,4.484-0.286,6.45,0.849l22.392,12.928c2.846,1.644,6.43,1.242,8.842-0.989c22.894-21.173,50.437-37.148,79.653-46.199
              c3.14-0.973,5.281-3.877,5.281-7.164V23.5c0-4.687,3.813-8.5,8.5-8.5h96c4.687,0,8.5,3.813,8.5,8.5v25.645
              c0,3.287,2.141,6.191,5.28,7.164c29.395,9.106,56.973,25.061,79.755,46.139c2.412,2.232,5.997,2.633,8.843,0.99l22.29-12.869
              c1.967-1.135,4.258-1.437,6.45-0.849c2.193,0.588,4.026,1.994,5.162,3.96l48,83.139c1.135,1.966,1.437,4.257,0.849,6.45
              c-0.588,2.193-1.994,4.026-3.96,5.161l-22.272,12.859c-2.844,1.642-4.289,4.943-3.566,8.146c3.431,15.206,5.17,30.704,5.17,46.065
              c0,15.1-1.765,30.584-5.247,46.021c-0.722,3.203,0.723,6.503,3.566,8.145l22.349,12.903
              C488.727,324.913,490.123,330.122,487.779,334.181z"/>
            <path fill="#fff" d="M255.5,104C171.962,104,104,171.963,104,255.5S171.962,407,255.5,407S407,339.037,407,255.5S339.038,104,255.5,104z
              M255.5,392C180.234,392,119,330.766,119,255.5S180.234,119,255.5,119S392,180.234,392,255.5S330.766,392,255.5,392z"/>
            <path fill="#fff" d="M283.5,216h-28c-4.142,0-7.5,3.358-7.5,7.5v64c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5V271h20.5
              c15.164,0,27.5-12.336,27.5-27.5S298.664,216,283.5,216z M283.5,256H263v-25h20.5c6.893,0,12.5,5.607,12.5,12.5
              S290.393,256,283.5,256z"/>
            <path fill="#fff" d="M214.522,220.867c-1.098-2.927-3.896-4.867-7.022-4.867h-8c-3.126,0-5.925,1.939-7.022,4.867l-24,64
              c-1.455,3.878,0.511,8.201,4.389,9.656c3.878,1.455,8.201-0.511,9.656-4.389L186.697,279h33.605l4.175,11.133
              c1.129,3.011,3.987,4.869,7.023,4.869c0.875,0,1.765-0.154,2.632-0.479c3.878-1.454,5.844-5.778,4.389-9.656L214.522,220.867z
              M192.322,264l11.178-29.807L214.678,264H192.322z"/>
            <path fill="#fff" d="M327.5,216c-4.142,0-7.5,3.358-7.5,7.5v64c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-64
              C335,219.358,331.642,216,327.5,216z"/>
            <path fill="#fff" d="M309.152,87.3c5.205,1.659,10.394,3.586,15.421,5.726c0.958,0.408,1.954,0.601,2.934,0.601c2.916,0,5.69-1.712,6.904-4.564
              c1.622-3.811-0.152-8.216-3.963-9.838c-5.458-2.323-11.09-4.415-16.742-6.216c-3.945-1.258-8.165,0.922-9.423,4.868
              C303.026,81.823,305.206,86.042,309.152,87.3z"/>
            <path fill="#fff" d="M100.45,339.904c-1.984-3.636-6.541-4.976-10.176-2.992c-3.636,1.984-4.976,6.54-2.992,10.176
              c3.112,5.704,6.557,11.315,10.239,16.677c1.454,2.117,3.801,3.255,6.189,3.255c1.463,0,2.941-0.427,4.239-1.318
              c3.415-2.345,4.282-7.014,1.937-10.428C106.493,350.332,103.318,345.161,100.45,339.904z"/>
            <path fill="#fff" d="M240.14,431.341c-40.189-3.463-78.337-20.879-107.416-49.041c-2.976-2.882-7.724-2.805-10.605,0.17
              c-2.881,2.976-2.806,7.724,0.17,10.605c31.55,30.555,72.947,49.452,116.563,53.21c0.219,0.019,0.436,0.028,0.652,0.028
              c3.851,0,7.127-2.949,7.464-6.856C247.323,435.331,244.266,431.697,240.14,431.341z"/>
            <path fill="#fff" d="M363.425,97.287c-3.42-2.337-8.087-1.459-10.424,1.96c-2.337,3.42-1.459,8.087,1.96,10.424
              c34.844,23.813,60.049,59.248,70.972,99.776c0.902,3.346,3.93,5.55,7.237,5.55c0.646,0,1.303-0.084,1.956-0.26
              c4-1.078,6.368-5.194,5.29-9.193C428.564,161.564,401.221,123.118,363.425,97.287z"/>
          </svg>
        </router-link>
      </li>
    </ul>
    <div class="header__body">
      <button class="menu-btn" v-if="!open" @click="open = !open, openMenu()" @mousedown="open = !open, openMenu()" :class="{ 'open' : open}">
            <svg version="1.1" width="28" height="28" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                <path fill="#000" d="M491.318,235.318H20.682C9.26,235.318,0,244.577,0,256s9.26,20.682,20.682,20.682h470.636
                  c11.423,0,20.682-9.259,20.682-20.682C512,244.578,502.741,235.318,491.318,235.318z"/>
                <path fill="#000" d="M491.318,78.439H20.682C9.26,78.439,0,87.699,0,99.121c0,11.422,9.26,20.682,20.682,20.682h470.636
                  c11.423,0,20.682-9.26,20.682-20.682C512,87.699,502.741,78.439,491.318,78.439z"/>
                <path fill="#000" d="M491.318,392.197H20.682C9.26,392.197,0,401.456,0,412.879s9.26,20.682,20.682,20.682h470.636
                  c11.423,0,20.682-9.259,20.682-20.682S502.741,392.197,491.318,392.197z"/>
            </svg>
          </button>
      <div class="view-bar">
          <div class="logo">
            <img class="logo__gutenberg" src="../assets/images/gutenberg_net.png" alt="" />
            <img src="../assets/images/media.png" alt="" />
          </div>
          <div class="user">
            <div class="user__name">
              Witaj, {{user.name}}
            </div>
            <div class="user__picture" :class="{
                'badge-red' : $parent.checkRole() == 'ROLE_SUPER_ADMIN' || $parent.checkRole() == 'ROLE_ADMIN',
                'badge-navy' : $parent.checkRole() == 'ROLE_COORDINATOR',
                'badge-blue' : $parent.checkRole() == 'ROLE_CENTRAL',
                'badge-green' : $parent.checkRole() == 'ROLE_LOCAL',
                'badge-violet' : $parent.checkRole() == 'ROLE_EDITOR',
                }">
              {{ $parent.translate($parent.checkRole()).substr(0,1) }}
            </div>
            <div class="logout">
              <button @click="logout()">Wyloguj</button>
            </div>
          </div>
      </div>
    </div>
    <reminder v-if="sessionReminder" @confirmed="clearStorage('sessionTimer'); sessionTimeout()" timer="120"/>
  </div>  
</template>

<script>

import { mixin as clickaway } from 'vue-clickaway';
import reminder from '@/components/blocks/appHeader/reminder.vue';
import { setTimeout } from 'timers';

export default {

    name: 'appHeader',
    mixins: [ clickaway ],
    components:{

      reminder,

    },
    data(){

      return{

        user: 'null',
        userName: '',

        open: false,
        logoutDropdown: false,

        //session variables

        sessionTimer: null,
        sessionReminder: false,
        sessionReminderTimer: null,
        userActive: true,
        firstUserAction: false,

      }

    },
    methods:{

      getUserName(){

        if(localStorage.getItem('user') != null){

          this.user = JSON.parse(localStorage.getItem('user'));

        }

      },

      awayLogout: function() {

        this.logoutDropdown = false;
        
      },

      logout(){

        this.$router.push("/");
        localStorage.clear();

      },

      openMenu(){

        let body = document.querySelector(".view-data");
        let copy = document.querySelector(".copyright");

        if(!body.classList.contains("body-wide") && this.open){

          body.className += " body-wide";
          copy.className += " body-wide";
          return;

        }

        body.classList.remove("body-wide");
        copy.classList.remove("body-wide");

      },

      sessionTimeout(){

        window.clearTimeout(this.sessionReminderTimer);
        window.clearTimeout(this.sessionTimer);
        this.sessionReminder = false;
            
        const session = (10000*6)*57;
        const reminder = (10000*6)*2;
        
        this.sessionTimer = window.setTimeout(() => {

          this.clearStorage('auth_token');
          this.clearStorage('refresh_token');
          this.$router.push('/');
          return;

        }, session);

        this.sessionReminderTimer = window.setTimeout(() => {

          this.sessionReminder = true;

        }, (session - reminder));

      },

      refreshSession(){

        const refreshTime = (10000*6)*30;

        if(!this.userActive || this.firstUserAction){

          if(!this.sessionReminder){

            this.firstUserAction = false;
            this.userActive = true;
          
            const refresh = {
              refresh_token: localStorage.getItem('refresh_token'),
            }

            const token = localStorage.getItem('auth_token');

            this.$http.post(`token/refresh`, refresh, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }).then(response => {

              setTimeout(()=>{
                this.userActive = false;
              }, refreshTime);
              
              localStorage.setItem('auth_token', response.data.token);
              localStorage.setItem('refresh_token', response.data.refresh_token);
              this.sessionTimeout();
              //this.clearStorage('sessionTimer');
              
            })
            .catch(error =>{

              this.sessionReminder = true;

            })

          }

        }

      },

    },
    watch: {

      '$route' (to, from, next) {

        if(this.open){
          this.open = true;
          this.openMenu();
        }

      }

    },
    mounted(){

      this.getUserName();
      this.openMenu();

      this.$root.$on('menu', data => {
          this.open = false;
      });

      if(!this.$route.path != '/user/password'){

        this.sessionTimeout();
        this.firstUserAction = true;

      }

    },

}
</script>

<style lang="scss">

$white: #fff;
$mediared: #e3000b;

.header{
  position: relative;
  display:flex;
  width:100%;
  justify-content: flex-end;
  
  background: $white;

  &__body{
    display:flex;
    width:100%;
    justify-content:flex-end;
    padding: 10px;
  }
}

.user{
  display:flex;
  align-items: center;
  position: relative;
  text-transform: capitalize;

  &__picture{
    display:flex;
    position: relative;
    align-items: center;
    justify-content: center;
    color:#fff;
    font-size: 18px;
    font-weight: 700;
    width:5rem;
    height:5rem;
    border-radius: 25px;
    margin:0px 10px;
    background:$mediared;
    cursor:pointer;

    &:hover .sub-tool{
      display:block;
    }
  }

  &:hover .logout{
    visibility: visible;
    display: block;
    z-index: 5000;
  }
}

.sub-tool{
  position: absolute;
  background:$mediared;
  padding:10px 20px;
  color:#fff;
  left:-200%;
  display:none;
}

.menu {
  position: fixed;
  top: 0;
  left: -100%;
  height: 100%;
  list-style-type: none;
  margin: 0;
  padding: 0;
  background: $mediared;
  z-index: 10;
  transition-duration: 0.2s;
}

.menu.open{
  left:0%;
  transition-duration: 0.2s;
  max-width: 70px;
}

.menu li a {
    display:flex;
    justify-content: center;
    align-items: center;
    width:5em;
    line-height:4em;
    position: relative;
    fill: black !important;
    color: transparent;
}

.menu li a svg {
  position: relative;
  width: 50%;
  height: 50%;
  width: 35px;
  height: 35px;
}

.menu li a:hover{
  background: $white;
}

.menu li a:hover svg path{
  fill: black;
}

.menu li.current a {
  background: $white;
  color: $white;
}

.menu li{
  position:relative;
  max-height: 56px;
  &:hover {
    background-color: #ffffff;

    svg path{
      fill: black;
    }

  }
  &.menu-control {
    &:hover {
      background-color: $mediared;

      svg path{
        fill: #ffffff;
      }

    }
  }
}

.bbc{
    position:absolute;
    left:5em;
    top:0;
    height:100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background:$white;
    padding: 1.2em 1.5em;
    visibility:hidden;
    white-space: nowrap;
    font-weight: 400;
}

.menu li:hover .bbc{
    visibility:visible;
}

.menu li.hovered{
  background: $white;
}

.menu li.hovered a svg{
  width:48%;
  height:49%;
  left:-2%;
}

.menu li.hovered .bbc{
  left:4.8em;
  height:103%;
  top:-1%;
}

.menu li.hovered svg path{
  fill: black !important;
}


.menu-control{
  margin-top:10%;
  margin-bottom:80%;
}

.menu-control a:hover{
    border:none !important;
    background: none !important;
    fill: white !important;
}

.menu-control a:hover svg path{
  fill: white !important;
}

.menu-control:hover:after{
    visibility:hidden !important;
}

.menu-btn{
  background: none;
  border: none;
  outline: none;
  margin-right: 30px;
}

.view-bar {
  display:flex;
  width:100%;
  right:0px;
  justify-content: space-between;
  align-items: center;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.menu.open ~ .header__body{
  width: calc(100% - 70px);
}

.logo{
  display:flex;
  justify-content: space-between;
  align-items: center;
  width:55%;

  & img{
    display:block;
    width:17rem;
  }

  &__gutenberg{
    width:37rem !important;
  }
}

.logout{
  position:absolute;
  display:flex;
  flex-direction: column-reverse;
  width:100%;
  top: 100%;
  right:10px;
  z-index: 2000;
  visibility: hidden;

  & button{
    width:100%;
    text-align: left;
    padding: 10px;
    background:none;
    border:none;
    background:#e6e6e6;
  }
}

</style>
